import { get } from '..';
import {
  NotificationSeverity, NotificationType, TicketPriority, TicketStatus,
} from '../../constants/Types';
import { isValidValue } from '../../constants/Utils';

interface GetNotificationsParams {
  buildingId: string,
  textsearch?: string,
  startDate?: string,
  endDate?: string,
  priority?: TicketPriority,
  severity?: number,
  type?: NotificationType,
  progression?: TicketStatus,
  limit?: number,
  offset?: number,
}

const getNotifications = ({
  buildingId, textsearch, startDate, endDate, priority, severity, type, progression, limit, offset,
}: GetNotificationsParams) => {
  let endpoint: string = `button/v2/notifications?locationId=${buildingId}`;
  if (textsearch) {
    endpoint += `&textsearch=${textsearch}`;
  }
  if (startDate) {
    endpoint += `&startdatetime=${startDate.toString()}`;
  }
  if (endDate) {
    endpoint += `&enddatetime=${endDate.toString()}`;
  }
  if (isValidValue(priority, TicketPriority)) {
    endpoint += `&priority=${priority}`;
  }
  if (isValidValue(severity, NotificationSeverity)) {
    endpoint += `&severity=${severity}`;
  }
  if (type) {
    endpoint += `&type=${type}`;
  }
  if (progression) {
    endpoint += `&status=${progression}`;
  }
  if (limit) {
    endpoint += `&limit=${limit}`;
  }
  if (offset) {
    endpoint += `&offset=${offset}`;
  }
  return get(endpoint);
};

export default getNotifications;
